import axios from "axios";
import service from "./service";

export default {
    setSessionID(ID){
        axios.defaults.params.session_id = ID;
    },
    createSession(device_id, pin) {
        return service.post('/kiosk/login', {
            device_id: device_id,
            pin: pin
        });
    },
    destroySession() {
        return service.delete('/kiosk/logout');
    },
}